import classNames from 'classnames';
import useStickerCommands from './useStickerCommands';
import './styles.scss';

export type StickerCommandsProps = {
  activeTab: string;
  profileId: string;
  studyFid: string | number;
};

/**
 * Displays the floating sticker that reports the queue of study-processing commands. Reads visibility, screen position and the command list from useStickerCommands, showing the first entry as the command in progress and the remaining count as pending.
 *
 * @param props - Sticker inputs identifying the active tab, profile and study whose command queue is shown.
 * @returns The rendered sticker listing the processing and pending commands.
 */
const StickerCommands = ({ activeTab, profileId, studyFid }: StickerCommandsProps) => {
  const { showSticker, position, commands } = useStickerCommands({
    activeTab,
    profileId,
    studyFid,
  });

  return (
    <div
      className={classNames('sticker-commands', showSticker ? '--visible' : '--hidden', position)}
    >
      <span>
        {'  '}
        Processing
        {'  '}
        {commands[0]}
        {'  '}
      </span>
      <span>
        {'  '}| Pending
        {'  '}
        {commands.length - 1}
        {'  '}
        commands
      </span>
    </div>
  );
};

export default StickerCommands;
